/**
 * RequestAttachmentService
 * Service for RequestAttachment entity operations
 * Route: api/requestattachment
 * Controller: RequestAttachmentController.cs
 */
import { CrudService } from '../base/CrudService';
/**
 * RequestAttachmentService
 * Handles request attachment CRUD operations
 * Maps to /api/requestattachment endpoint
 */
export class RequestAttachmentService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? RequestAttachmentService.DEFAULT_SERVICE_PATH,
            basePath: RequestAttachmentService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    async getAllViewModels() {
        const response = await this.http.get(this.buildUrl('view-models'));
        return response.data ?? [];
    }
}
RequestAttachmentService.DEFAULT_SERVICE_PATH = 'procurements';
RequestAttachmentService.BASE_PATH = 'api/requestattachment';
//# sourceMappingURL=RequestAttachmentService.js.map